export const PLATFORM_FEE_COLLECTOR = "0x8302A634B6D67a92DBd28395D407A6DF6cc767D4" as `0x${string}`;

export interface ReferralCode {
  code: string;
  referrerAddress: `0x${string}`;
  isActive: boolean;
  createdAt?: Date;
  expiryDate?: Date;
}

// Store referral codes in localStorage
const STORAGE_KEY = 'pump_referral_codes';

// Initialize with default code
const defaultCodes: ReferralCode[] = [
  {
    code: "LAUNCH2024",
    referrerAddress: PLATFORM_FEE_COLLECTOR,
    isActive: true,
    createdAt: new Date(),
    expiryDate: new Date(2024, 11, 31) // Expires Dec 31, 2024
  }
];

export const getReferralCodes = (): ReferralCode[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(defaultCodes));
      return defaultCodes;
    }
    const codes = JSON.parse(stored);
    // Convert string dates back to Date objects
    return codes.map((code: ReferralCode) => ({
      ...code,
      createdAt: code.createdAt ? new Date(code.createdAt) : undefined,
      expiryDate: code.expiryDate ? new Date(code.expiryDate) : undefined
    }));
  } catch (error) {
    console.error('Error reading referral codes:', error);
    return defaultCodes;
  }
};

export const addReferralCode = (newCode: Omit<ReferralCode, 'createdAt'>): boolean => {
  try {
    const codes = getReferralCodes();
    if (codes.some(code => code.code === newCode.code)) {
      return false; // Code already exists
    }
    
    const updatedCodes = [
      ...codes,
      { ...newCode, createdAt: new Date() }
    ];
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedCodes));
    return true;
  } catch (error) {
    console.error('Error adding referral code:', error);
    return false;
  }
};

export const validateReferralCode = (code: string): ReferralCode | null => {
  try {
    const codes = getReferralCodes();
    const referralCode = codes.find(rc => rc.code === code && rc.isActive);
    
    if (!referralCode) return null;
    
    // Check if the code has expired
    if (referralCode.expiryDate && new Date() > new Date(referralCode.expiryDate)) {
      return null;
    }
    
    return referralCode;
  } catch (error) {
    console.error('Error validating referral code:', error);
    return null;
  }
};

export const DISCOUNTED_PLATFORM_FEE = 0.015; // 1.5%
export const REFERRER_FEE = 0.005; // 0.5%
